import React from 'react';

type TStorageIcon = {
  className?: string;
  style?: any;
  color?: string;
};

export const StorageIcon: React.FC<TStorageIcon> = ({ className, style, color }) => (
  <svg width="42px" height="42px" className={className} style={style} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M7 19L5.78311 18.9954C3.12231 18.8818 1 16.6888 1 14C1 11.3501 
        3.06139 9.18169 5.66806 9.01084C6.78942 6.64027 9.20316 5 12 5C15.5268 
        5 18.4445 7.60822 18.9293 11.001L19 11C21.2091 11 23 12.7909 23 15C23 17.1422 
        21.316 18.8911 19.1996 18.9951L17 19M12 20V12M12 12L15 15M12 12L9 15"
        stroke={color ? color : '#FFFFFF'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>{' '}
    </g>
  </svg>
);
